var render = function render(){var _vm=this,_c=_vm._self._c;return _c('paper-plane-icon',{staticClass:"paper-plane-icon"})
}
var staticRenderFns = []

export { render, staticRenderFns }